const config = {
  apiUrl:
    process.env.NODE_ENV === 'production'
      ? 'https://tu2f7g5k7yyf4jm3t5xcjuo4i40cukrd.lambda-url.ap-northeast-2.on.aws'
      : 'http://localhost:4000', // Production API URL
};

export default config;
